import { Col, Row } from 'antd';
import { ReportList } from './ReportList';
import s from './Reports.module.scss';

export function Reports() {
  return (
    <Row gutter={[14, 14]} className={s['root__reports-grid']}>
      <Col xs={24}>
        <ReportList />
      </Col>
    </Row>
  );
}
